export const EXAM = [
  'GENERAL_ANESTHESIA',
  'SPINAL',
  'EPIDURAL',
  'PEDIATRIK',
  'PENYULIT',
  'PERIPHERAL_BLOK',
  'KOMPREHENSIF',
];
